
export default class FormularFeltUtil {
  static escapeForDomId (value: string): string {
    if (!value) return ''
    return value.replaceAll(':', '-').replaceAll('.', '_').replaceAll('[', '--').replaceAll(']', '').replaceAll('@', '_at_')
  }
}
